@if (shouldSlide$ | async) {
  <div class="swiper-container">
    <div class="overlay"></div>
    @if (swiperOptions$ | async; as swiperOptions) {
      <swiper
        [config]="swiperOptions"
        (swiper)="onSwiper($event)"
        (slideChange)="onSlideChange()"
        >
        @for (paragraph of paragraphCarousels; track paragraph) {
          <ng-template swiperSlide>
            <ng-container [ngTemplateOutlet]="paragraphTemplate" [ngTemplateOutletContext]="{ p: paragraph }"></ng-container>
          </ng-template>
        }
      </swiper>
    }
  </div>
} @else {
  <div class="no-carousel">
    @for (paragraph of paragraphCarousels; track paragraph) {
      <ng-container [ngTemplateOutlet]="paragraphTemplate" [ngTemplateOutletContext]="{ p: paragraph }"></ng-container>
    }
  </div>
}

<div class="pagination-container" [class.hidden]="(shouldSlide$ | async) === false">
  @if (swiper && swiper.totalIndex && swiper.totalIndex > 1) {
    <p>
      {{swiper.swiperIndex}}/{{swiper.totalIndex}}
    </p>
  }

  <div #pagination></div>

  @if (swiper && swiper.totalIndex && swiper.totalIndex > 1) {
    <div>
      <span appIcon="arrow-left"
        class="navigation-icon"
        [ngClass]="swiper.swiper.isBeginning ? 'disabled' : 'enabled'"
        (click)="swiper.slidePrev()"
      ></span>
      <span appIcon="arrow-right"
        class="navigation-icon"
        [ngClass]="swiper.swiper.isEnd ? 'disabled' : 'enabled'"
        (click)="swiper.slideNext()"
      ></span>
    </div>
  }
</div>

<ng-template #paragraphTemplate let-p="p">
  @if (p | asParagraphFragment; as paragraph) {
    <div class="paragraph-container">
      <div class="card">
        <h3 class="text-primary">
          {{paragraph.title}}
        </h3>
        <p class="small text-grey-5">
          {{paragraph.paragraph}}
        </p>
      </div>
    </div>
  }
</ng-template>

